import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm.js";
import { useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./TechnicianInventoryFile.js";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput.js";
import { validate } from "../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../Loader/Loader.js";
import { loaderOverlay } from "../../Style/loaderOverly.js";
import NumberInput from "../../custom/components/Number-Input/NumberInput.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../custom/components/Text-Input/TextInput.js";

const TechnicianInventoryCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  } = createPageData();

  const schema = localStorage.getItem("schema");
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const [technicianSelectOptions, setTechnicianSelectOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemSelectOptions, setItemSelectOptions] = useState([]);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    getTechniciansData();
    geMaterialsData();
  }, []);

  useEffect(() => {
    if (!selectedItem || !selectedItem.value) {
      return;
    }

    getAvailableQtyData();
  }, [selectedItem?.value]);

  const getAvailableQtyData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        material_id: selectedItem?.value,
      };

      const responseData = await getRecords(
        payload,
        "/materials/inventory-available-qty"
      );
      const quantity = responseData?.available_qty;

      setFormData((prev) => ({
        ...prev,
        inputData: {
          ...prev.inputData,
          available_quantity: quantity ?? 0,
        },
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const getEditData = async (id) => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data });
        setSelectedTechnician({
          value: data?.technician_id,
          label: `${data?.technician?.first_name} ${data?.technician?.last_name}`,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getTechniciansData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "user_masters",
        schema: schema,
        whereCondition: {
          is_active: true,
          role_id: 2,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: `${item.first_name} ${item.last_name}`,
      }));
      setTechnicianSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };
  const geMaterialsData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "material_masters",
        schema: schema,
        whereCondition: {
          is_active: true,
        },
        include: [
          {
            model: "category_masters",
            as: "category",
            where: {
              type: 1,
            },
            required: true,
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setItemSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };
  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevformErrors) => {
      let errors = { ...prevformErrors };

      const fieldError = validate(validationType, { [name]: value });
      errors[name] = fieldError[name] || null;

      if (name === "quantity") {
        const enteredQty = Number(value);
        const availableQty = Number(
          formData?.inputData?.available_quantity || 0
        );

        if (enteredQty > availableQty) {
          errors.quantity =
            "Require quantity must be less than or equal to available quantity";
        }
      }

      return errors;
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
            ? null
            : value,
      },
    }));
  };

  const handleTechnicianSelect = async (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      technician_id: selectedValue,
    });

    setSelectedTechnician(options);
    setFormErrors((prevformErrors) => ({
      ...prevformErrors,
      technician_id: fieldError?.technician_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        technician_id: selectedValue,
      },
    }));
  };
  const handleItemSelect = async (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      material_id: selectedValue,
    });

    setSelectedItem(options);
    setFormErrors((prevformErrors) => ({
      ...prevformErrors,
      material_id: fieldError?.material_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        material_id: selectedValue,
      },
    }));
  };

  const handleSubmit = async (e) => {
    if (
      Number(formData?.inputData?.quantity) >
      Number(formData?.inputData?.available_quantity)
    ) {
      setFormErrors((prev) => ({
        ...prev,
        quantity:
          "Require quantity must be less than or equal to available quantity",
      }));

      return;
    }
    try {
      e.preventDefault();
      setLoadingData(true);

      const validationformErrors = validate(validationType, formData.inputData);
      setFormErrors(validationformErrors);
      if (JSON.stringify(validationformErrors) !== "{}") return;
      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        inputData: {
          ...formData?.inputData,
          quantity: parseInt(formData?.inputData?.quantity),
          available_quantity: parseInt(formData?.inputData?.available_quantity),
          created_by: userDetails?.id,
          updated_by: userDetails?.id,
        },
      };

      // console.log(payload);
      // return;

      const responseData = await saveRecords(payload, endpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  // add document

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="Select Technician"
            options={technicianSelectOptions}
            value={selectedTechnician}
            onSelect={handleTechnicianSelect}
            placeholder="Select Technician"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.technician_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Select Item"
            options={itemSelectOptions}
            value={selectedItem}
            onSelect={handleItemSelect}
            placeholder="Select Item"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.material_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Available Quantity"
            name="available_quantity"
            value={formData?.inputData?.available_quantity}
            placeholder="Available Quantity"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.available_quantity}
            disabled={true}
          />
        </Col>

        <Col md="6" className="mt-3">
          <NumberInput
            label="Require Quantity"
            name="quantity"
            value={formData?.inputData?.quantity}
            onChange={onInputChange}
            placeholder="Require Quantity"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.quantity}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default TechnicianInventoryCreate;
